import React from 'react';
import { cn } from '../../lib/utils';

const Input = React.forwardRef((props, ref) => {
  const { className, type, ...otherProps } = props;
  return (
    <input
      type={type}
      className={cn(
        "flex f-full w-full rounded-[10px] border border-input bg-white px-3 py-4 text-[1rem] ring-offset-primary file:border-0 file:bg-transparent file:text-[1rem] file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...otherProps}
    />
  );
});

Input.displayName = 'Input';

export { Input };